export default __webpack_public_path__ + "static/media/Mietje.32357afe.png";